import { useState, useCallback } from 'react'
import { useToasts } from 'react-toast-notifications'
import useQuery from '_hooks/useQuery'

export default function useShareGroup({ groupId } = {}) {
  const params = useQuery()
  const { addToast } = useToasts()
  const [isCopying, setIsCopying] = useState(false)

  const currentGroupId = groupId || params?.get('groupId')
  const shareLink = currentGroupId
    ? `${process.env.REACT_APP_APP_URL}/group/join/${currentGroupId}`
    : window.location.href

  const handleShare = useCallback(async () => {
    if (isCopying) return
    setIsCopying(true)

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareLink)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = shareLink
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }

      addToast('Link copied', { appearance: 'success', autoDismiss: true })
    } catch (err) {
      addToast('Failed to copy link', { appearance: 'error', autoDismiss: true })
    } finally {
      setTimeout(() => {
        setIsCopying(false)
      }, 600)
    }
  }, [isCopying, shareLink, addToast])

  return {
    isCopying,
    handleShare,
    shareLink,
  }
}
